import type { MenuItem } from "@/types";

export const slugifyItemName = (name: string): string =>
  String(name || "item")
    .normalize("NFKD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/&/g, " and ")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "") || "item";

/** Name plus permanent id keeps URLs readable without collisions after renames. */
export const itemSlug = (item: Pick<MenuItem, "_id" | "name">): string =>
  `${slugifyItemName(item.name)}--${encodeURIComponent(String(item._id))}`;

export const itemPath = (item: Pick<MenuItem, "_id" | "name">): string =>
  `/menu/item/${itemSlug(item)}`;

export const itemIdFromSlug = (slug: string): string => {
  const marker = String(slug || "").lastIndexOf("--");
  const encoded = marker >= 0 ? slug.slice(marker + 2) : slug;
  try { return decodeURIComponent(encoded); } catch { return encoded; }
};

export const findItemBySlug = (items: MenuItem[], slug: string): MenuItem | undefined => {
  const id = itemIdFromSlug(slug);
  return items.find((item) => String(item._id) === id) ??
    items.find((item) => itemSlug(item) === slug);
};
